import { UseFormReturn } from 'react-hook-form';

const usePlateFocusInputs = <T>({
  methods,
}: {
  methods: UseFormReturn<any, any, any>;
}) => {
  const focus = ({
    nextName,
    previous,
    value,
    length,
  }: {
    nextName: T | '';
    previous: T | '';
    value: string;
    length: number;
  }) => {
    if (nextName && value.length === length) {
      methods.setFocus(nextName as string);
    }
    if (previous && value.length === 0) {
      methods.setFocus(previous as string);
    }
  };
  return { focus };
};

export default usePlateFocusInputs;
